import { render, staticRenderFns } from "./TimerCorrections.vue?vue&type=template&id=ef8dd8c8"
import script from "./TimerCorrections.vue?vue&type=script&lang=js"
export * from "./TimerCorrections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports